import { defineStore } from 'pinia';
import { BusinessState, IEditBomData } from './types';

const useBusinessStore = defineStore('business', {
  state: (): BusinessState => ({
    production: {
      refreshOrder: false, // 刷新生产单
      refreshGoodsId: undefined, // 根据goodsId刷新生产单商品
      editBomData: new Map(), // 修改生产单物料bom清单用到的数据
      isCopy: false, // 记录本次跳转修改bom是否是复制生产单页面
    },
    purchase: {
      refreshMaterialDemand: false, // 刷新生产单
    },
  }),

  getters: {},

  actions: {
    setRefreshOrder(data?: boolean) {
      this.production.refreshOrder = data ?? false;
    },
    setRefreshMaterialDemand(data?: boolean) {
      this.purchase.refreshMaterialDemand = data ?? false;
    },
    setRefreshGoodsId(data?: number) {
      this.production.refreshGoodsId = data;
    },
    setEditBomData(ordersSn: string, data?: IEditBomData) {
      if (data) {
        this.production.editBomData.set(ordersSn, data);
      } else {
        this.production.editBomData.delete(ordersSn);
      }
    },
    getEditBomData(ordersSn: string) {
      return this.production.editBomData.get(ordersSn);
    },
    setIsCopyProduction(copy?: boolean) {
      this.production.isCopy = copy ?? false;
    },
  },
});

export default useBusinessStore;
